import { AcceptDocument } from '../interface/accept-document.interface';
export class OrderInfoTab {
  orderID: string;
  webOrderID: string;
  orderNumber: string;
  homeCountry: string;
  distributorID: string;
  disabled: boolean;
  removable: boolean;
  title: string;
  active: boolean;
  componentName: string;
  recentOrder: boolean;
  newOrder: boolean;
  closeNewOrderTab: boolean;
  tabForOrderPromotion: boolean;
  retailID: string;
  emailID?: string;
  acceptDocuments?:AcceptDocument;
}



// WEBPACK FOOTER //
// ./src/app/customerservice/models/order-info-tab-model.ts